import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Store } from '@ngrx/store';

import { menuChange } from '../sidebar/redux/sidebar.actions';

@Component({
  selector: 'app-cohort-selector-modal',
  templateUrl: './cohort-selector-modal.component.html',
  styleUrls: ['./cohort-selector-modal.component.scss'],
})
export class CohortSelectorModalComponent implements OnInit {
  @Input() public sideBarData;
  @Input() public sideMenuData;

  constructor(
    public popoverController: PopoverController,
    private store: Store<any>,
  ) { }

  public ngOnInit() {
  // block 
  }
  public async closeModal(cohortId: number) {
    await this.popoverController.dismiss({
      cohortId
    });
  }
  public setSelectedCohort(cohort: { cohortId: number }) {
    this.store.dispatch(menuChange({ cohortId: cohort.cohortId }));
    this.closeModal(cohort.cohortId);
  }
}
